<div class="sections-wrapper">
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.COMPRESSOR' | translate }}"
  >
    <div class="feature-grid-container" viFeatureGrid viBorderBottom>
      <!-- heating.compressors.0 -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="compressor"
        *ngIf="refrigerantCircuitStatus$ | async | ready as feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.LABEL' | translate }}:"
        [value]="
          feature.properties?.active?.value
            | booleanSuffix
              : [
                  customTranslationsService.STATE.on | translate,
                  customTranslationsService.STATE.off | translate
                ]
        "
      >
      </app-feature-list-item>

      <!-- heating.coolingCircuits.0.type -->
      <app-feature-list-item
        *ngIf="refrigerantCircuitGeneration$ | async | ready as feature"
        data-at-refrigerant-circuit-generation-feature="refrigerantCircuitGeneration"
        [attr.data-feature]="feature.feature"
        label="{{
          '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_GENERATION.TITLE' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.value }}"
      >
      </app-feature-list-item>

      <!-- device.offPeak -->
      <app-feature-list-item
        *ngIf="offPeakSignal$ | async | ready as feature"
        [attr.data-at-device-pvSignal-active]="feature.properties?.currentState?.value"
        data-at-refrigerant-circuit-overlay-feature="offPeakSignal"
        [attr.data-feature]="feature.feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.TITLE' | translate }}:"
        value="{{
          feature.properties?.currentState?.value === offPeakSignal.economyTariff
            ? ('+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.ECONOMY' | translate)
            : ('+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.PREMIUM' | translate)
        }}"
      ></app-feature-list-item>

      <!-- device.pvSignal -->
      <app-feature-list-item
        *ngIf="pvSignal$ | async | ready as feature"
        data-at-refrigerant-circuit-overlay-feature="pvSignalActive"
        [attr.data-feature]="feature.feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.PHOTOVOLTAIC_ACTIVE.TITLE' | translate }}:"
        value="{{
          feature.properties?.currentState?.value === pvAvailable
            ? ('+INSTALLATIONS.INSTALLATION.PV_SIGNAL_ACTIVE_STATUS' | translate)
            : ('+INSTALLATIONS.INSTALLATION.PV_SIGNAL_NOT_ACTIVE_STATUS' | translate)
        }}"
      ></app-feature-list-item>

      <!-- heating.noise.reduction.operating.programs.active -->
      <app-feature-list-item
        data-at-refrigerant-circuit-overlay-feature="noiseReduction"
        *ngIf="heatingNoiseReductionMode$ | async as mode"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.NOISE_REDUCTION.TITLE' | translate }}:"
        value="{{
          '+INSTALLATIONS.INSTALLATION.HEAT_PUMP.NOISE_REDUCTION.VALUES.' + mode.toUpperCase()
            | translate
        }}"
      >
      </app-feature-list-item>

      <!-- heating.primaryCircuit.spaceFrostProtection -->
      <ng-container feature *ngIf="spaceFrostProtection$ | async | ready as feature">
        <app-feature-list-item
          data-at-refrigerant-circuit-overlay-feature="spaceFrostProtection"
          feature
          [attr.data-at-space-frost-protection]="feature.properties?.active?.value"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.SPACE_FROST_PROTECTION'
              | translate
          }}:
          "
          [value]="
            feature.properties?.active?.value
              | booleanSuffix
                : [
                    customTranslationsService.STATE.on | translate,
                    customTranslationsService.STATE.off | translate
                  ]
          "
        ></app-feature-list-item>
      </ng-container>

      <!-- heating.dhw.dhwCylinder.frostprotection -->
      <ng-container feature *ngIf="frostProtection$ | async | ready as feature">
        <app-feature-list-item
          feature
          data-at-refrigerant-circuit-overlay-feature="dhwFrostProtection"
          [attr.data-at-frost-protection]="feature.properties?.status?.value"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.DHW_FROST_PROTECTION'
              | translate
          }}:
          "
          [value]="
            feature.properties?.status?.value === OnOff.on
              | booleanSuffix
                : [
                    customTranslationsService.STATE.on | translate,
                    customTranslationsService.STATE.off | translate
                  ]
          "
        ></app-feature-list-item>
      </ng-container>

      <ng-container *ngIf="spaceFrostProtectionConfiguration$ | async | ready as feature">
        <div
          class="dropdown-container frost-protection"
          data-at-refrigerant-circuit-overlay-feature="spaceFrostProtectionThreshold"
        >
          <div class="dropdown-title">
            <p data-at-value>
              {{
                '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.SPACE_FROST_PROTECTION_THRESHOLD'
                  | translate
              }}
            </p>
          </div>

          <mat-form-field mat-select-height-small class="dropdown">
            <mat-select
              data-at-space-frost-protection-dropdown
              data-at-value
              [value]="temperatureForDropdownValue.value"
              (valueChange)="onTemperatureChange($event)"
            >
              <mat-option
                data-at-option
                *ngFor="let temperature of availableTemperatureForDropdown"
                [value]="temperature.value"
              >
                {{ temperature.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- heating.primaryCircuit.configuration.preVentilation -->
      <ng-container *ngIf="primaryCircuitConfigurationPreVentilation$ | async | ready as feature">
        <div class="dropdown-container frost-protection">
          <div class="dropdown-title">
            <p>
              {{
                '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.DURATION_PRE_VENTILATION'
                  | translate
              }}
            </p>
          </div>

          <mat-form-field mat-select-height-small class="dropdown">
            <mat-select
              data-at-space-frost-protection-dropdown
              [value]="minutesForDropdownValue.value"
              (valueChange)="onMinutesChange($event)"
            >
              <mat-option *ngFor="let minute of availableMinutesForDropdown" [value]="minute.value">
                {{ minute.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
      <!-- heating.coolingCircuits.0.eev.type -->
      <app-feature-list-item
        *ngIf="typeElectronicExpansionValve$ | async | ready as feature"
        data-at-type-electronic-expansion-valve-feature="typeElectronicExpansionValve"
        [attr.data-feature]="feature.feature"
        label="{{
          '+INSTALLATIONS.INSTALLATION.TYPE_ELECTRONIC_EXPANSION_VALVE.TITLE' | translate
        }}:"
        value="{{ feature | value2: featurePropertyKey.value }}"
      >
      </app-feature-list-item>

      <!-- heating.compressors.0.power -->
      <ng-container *ngIf="ratedOutputCompressorStage$ | async | ready as feature">
        <app-feature-list-item
          *ngrxLet="authStore.isRsaUserWithWriteRights() | async as isRsaUserWithWriteRights"
          data-at-rated-output-compressor-stage-feature="ratedOutputCompressorStage"
          [attr.data-feature]="feature.feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.RATED_OUTPUT_COMPRESSOR_STAGE.TITLE' | translate
          }}:"
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [labelInfoTooltip]="
            '+INSTALLATIONS.INSTALLATION.RATED_OUTPUT_COMPRESSOR_STAGE.TOOLTIP' | translate
          "
          [isNgContent]="feature.commands?.setValue?.isExecutable && isRsaUserWithWriteRights"
        >
          <vi-item
            data-at-rated-output-compressor-stage
            id="select-rated-output-compressor-stage"
            [asDropdown]="true"
            [valueSpecification]="feature | constraints: 'setValue':'value'"
            [value]="feature.properties?.value?.value"
            [unit]="feature.properties?.value?.unit"
            [sizeOfDropdownBox]="'small'"
            (valueChange)="onSelectRatedOutputCompressorStage($event)"
          ></vi-item>
        </app-feature-list-item>
      </ng-container>

      <!-- heating.compressors.0.statistics -->
      <ng-container *ngIf="compressorStatistics$ | async | ready as feature">
        <!-- heating.compressors.0.statistics.hours -->
        <app-feature-list-item
          data-at-refrigerant-circuit-overlay-feature="hours"
          label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMPRESSOR_HOURS' | translate }}:"
          value="{{ feature?.properties?.hours?.value | toFixed: 0 }} {{ feature | unit: 'hours' }}"
          [attr.data-feature]="feature.feature + '/hours'"
          [error]="feature | error"
        >
        </app-feature-list-item>

        <!-- heating.compressors.0.statistics.starts -->
        <app-feature-list-item
          data-at-refrigerant-circuit-overlay-feature="runs"
          label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.COMPRESSOR_RUNS' | translate }}:"
          [value]="feature.properties?.starts?.value | toFixed: 0"
          [attr.data-feature]="feature.feature + '/starts'"
          [error]="feature | error"
        >
        </app-feature-list-item>

        <app-feature-list-item
          *ngIf="
            isClockingDataAvailable(
              feature?.properties?.starts?.value,
              feature?.properties?.hours?.value
            )
          "
          data-at-refrigerant-circuit-overlay-feature="clocking"
          label="{{ '+INSTALLATIONS.INSTALLATION.BOILER.BURNER_CLOCKING' | translate }}:"
          [value]="
            calculateClocking(feature?.properties?.starts?.value, feature?.properties?.hours?.value)
              | minutesOrHours
          "
          [attr.data-feature]="compressorStatistics$ | async | ready"
          [error]="compressorStatistics$ | async | ready | error"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- heating.compressors.0.speed.current -->
      <app-feature-list-item
        *ngIf="compressorRPM$ | async as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.COMPRESSOR_RPM' | translate"
        value="{{ feature?.properties?.value?.value | suffix: suffix.rotationPerMinute }}"
        [attr.data-feature]="feature.feature"
      ></app-feature-list-item>
    </div>
  </app-feature-list-container>

  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.BOILER.DETAILS' | translate }}"
    [tooltipText]="
      '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.DETAILS_PANEL.TOOLTIP' | translate
    "
  >
    <div class="details-grid-wrapper">
      <div>
        <app-feature-list-item
          data-at-heating-primaryCircuit-sensors-temperature-supply
          *ngIf="airInletTemperature$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.AIR_INLET_TEMPERATURE.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.AIR_INLET_TEMPERATURE.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        >
        </app-feature-list-item>
        <app-feature-list-item
          data-at-heating-evaporators-0-sensors-temperature-liquid
          *ngIf="evaporationTemperature$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EVAPORATION_TEMPERATURE.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EVAPORATION_TEMPERATURE.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        >
        </app-feature-list-item>
        <app-feature-list-item
          *ngIf="suctionGasTemperature$ | async | ready as feature"
          data-at-heating-evaporators-0-sensors-temperature-overheat
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.SUCTION_GAS_TEMPERATURE.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.SUCTION_GAS_TEMPERATURE.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
        <app-feature-list-item
          data-at-heating-compressors-0-sensors-temperature-inlet
          *ngIf="suctionGasTemperatureCompressor$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.SUCTION_GAS_TEMPERATUE_COMPRESSOR.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.SUCTION_GAS_TEMPERATUE_COMPRESSOR.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
        <app-feature-list-item
          data-at-heating-compressors-0-sensors-pressure-inlet
          *ngIf="lowPressureCompressor$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.LOW_PRESSURE_COMPRESSOR.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.LOW_PRESSURE_COMPRESSOR.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        >
        </app-feature-list-item>
      </div>
      <div>
        <app-feature-list-item
          data-at-heating-economizers-0-sensors-temperature-liquid
          *ngIf="hotGasTemperature$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOT_GAS_TEMPERATURE.LABEL' | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOT_GAS_TEMPERATURE.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
        <app-feature-list-item
          data-at-heating-condensors-0-sensors-temperature-liquid
          *ngIf="liquidGasTemperature$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.LIQUID_GAS_TEMPERATURE.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.LIQUID_GAS_TEMPERATURE.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
        <app-feature-list-item
          data-at-heating-compressors-0-sensors-temperature-outlet
          *ngIf="hotGasTemperatureCompressor$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOT_GAS_TEMPERATURE_COMPRESSOR.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOT_GAS_TEMPERATURE_COMPRESSOR.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
        <app-feature-list-item
          data-at-heating-compressors-0-sensors-pressure-outlet
          *ngIf="highPressureCompressor$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HIGH_PRESSURE_COMPRESSOR.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HIGH_PRESSURE_COMPRESSOR.TOOLTIP'
              | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
      </div>
      <div>
        <app-feature-list-item
          data-at-heating.primaryCircuit.fans.0.current
          *ngIf="fanOneActualValue$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.FAN_ONE_ACTUAL_VALUE.LABEL' | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.FAN_ONE_ACTUAL_VALUE.TOOLTIP'
              | translate
          "
          value="{{ fanOneActualValue$ | async | value2: featurePropertyKey.value }} {{
            fanOneActualValue$ | async | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>

        <app-feature-list-item
          data-at-heating.primaryCircuit.fans.1.current
          *ngIf="fanTwoActualValue$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.FAN_TWO_ACTUAL_VALUE.LABEL' | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.FAN_TWO_ACTUAL_VALUE.TOOLTIP'
              | translate
          "
          value="{{ fanTwoActualValue$ | async | value2: featurePropertyKey.value }} {{
            fanTwoActualValue$ | async | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>

        <app-feature-list-item
          data-at-heating-sensors-valve-0-expansion-target
          *ngIf="electronicExpansionValveOneSetpoint$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_ONE_SETPOINT.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_ONE_SETPOINT.TOOLTIP'
              | translate
          "
          value="{{
            electronicExpansionValveOneSetpoint$ | async | value2: featurePropertyKey.value
          }} {{ electronicExpansionValveOneSetpoint$ | async | unit: featurePropertyKey.value }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>

        <app-feature-list-item
          data-at-heating-sensors-valve-0-expansion
          *ngIf="electronicExpansionValveOneActualValue$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_ONE_ACTUAL_VALUE.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_ONE_ACTUAL_VALUE.TOOLTIP'
              | translate
          "
          value="{{
            electronicExpansionValveOneActualValue$ | async | value2: featurePropertyKey.value
          }} {{ electronicExpansionValveOneActualValue$ | async | unit: featurePropertyKey.value }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>

        <app-feature-list-item
          data-at-heating-sensors-valve-1-expansion-target
          *ngIf="electronicExpansionValveTwoSetpoint$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_TWO_SETPOINT.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_TWO_SETPOINT.TOOLTIP'
              | translate
          "
          value="{{
            electronicExpansionValveTwoSetpoint$ | async | value2: featurePropertyKey.value
          }} {{ electronicExpansionValveTwoSetpoint$ | async | unit: featurePropertyKey.value }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>

        <app-feature-list-item
          data-at-heating-sensors-valve-1-expansion
          *ngIf="electronicExpansionValueTwoActualValue$ | async | ready as feature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_TWO_ACTUAL_VALUE.LABEL'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.ELECTRONIC_EXPANSION_VALVE_TWO_ACTUAL_VALUE.TOOLTIP'
              | translate
          "
          value="{{
            electronicExpansionValueTwoActualValue$ | async | value2: featurePropertyKey.value
          }} {{ electronicExpansionValueTwoActualValue$ | async | unit: featurePropertyKey.value }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-list-item>
      </div>
    </div>
  </app-feature-list-container>

  <ng-container *ngIf="noiseReduction$ | async | ready as noiseReductionFeature">
    <ng-container *ngIf="noiseReducationSchedule$ | async | ready as noiseReducationSchedule">
      <div class="section-wrapper">
        <h3 data-at-refrigerant-circuit-noise-reduction-section class="section-heading">
          {{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.NOISE_REDUCTION_TIME_PROGRAM'
              | translate
          }}
        </h3>

        <div
          class="flex flex-row justify-start items-center"
          *ngIf="
            (authStore.isEndUser$ | async) &&
            noiseReductionFeature.commands?.setChangeableByEndCustomer?.isExecutable
          "
        >
          <div
            class="toggle-wrapper"
            data-at-refrigerant-circuit-schedule-editable-by-customer-toggle
            [viConfirm]="
              noiseReductionFeature.properties?.changeableByEndCustomer?.value
                ? {
                    title:
                      '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EDITABLE_BY_END_CUSTOMER_SWITCH_FALSE'
                      | translate,
                    content:
                      '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EDITABLE_BY_END_CUSTOMER_DESCRIPTION_REVOKE'
                      | translate,
                    cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                    confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
                  }
                : {
                    title:
                      '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EDITABLE_BY_END_CUSTOMER_SWITCH_TRUE'
                      | translate,
                    content:
                      '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EDITABLE_BY_END_CUSTOMER_DESCRIPTION'
                      | translate,
                    cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                    confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
                  }
            "
            gtm="onToggle"
            gtmAction="Switch editable by customer"
            gtmCategory="Manage features"
            [attr.data-at-checked]="
              noiseReductionFeature.properties?.changeableByEndCustomer?.value
            "
            (confirm)="
              onEditableByEndCustomerToggle(
                !noiseReductionFeature.properties?.changeableByEndCustomer?.value
              )
            "
          >
            <mat-slide-toggle
              class="deactivated"
              [checked]="noiseReductionFeature.properties?.changeableByEndCustomer?.value"
            >
            </mat-slide-toggle>
          </div>
          <div>
            {{
              '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.EDITABLE_BY_END_CUSTOMER' | translate
            }}
          </div>
        </div>

        <app-timemanager
          [class.interaction-disabled]="
            !noiseReductionFeature.properties?.changeableByEndCustomer?.value
          "
          (scheduleChange)="onScheduleChange($event, noiseReducationSchedule)"
        ></app-timemanager>

        <div class="programs-container gap flex flex-row justify-between items-center">
          <div class="programs-container gap flex flex-row justify-between items-center">
            <button
              mat-stroked-button
              color="primary"
              gtm="onOpen"
              gtmAction="Multiple days selection dialog"
              gtmCategory="noiseReducationSchedule"
              id="edit-multiple-noise-reduction-btn"
              data-at-edit-multiple
              [disabled]="!noiseReductionFeature.properties?.changeableByEndCustomer?.value"
              (click)="onEditMultipleDays()"
            >
              {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
            </button>
          </div>

          <div data-at-programs class="programs flex flex-row flex-wrap">
            <vi-program-item
              *ngFor="let program of programs$ | async"
              program="{{ program.css }}"
              [hasTemperature]="false"
            >
              <vi-text name class="flex-1">
                {{ program?.name | translateOperatingProgram }}
              </vi-text>
            </vi-program-item>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="gatewayStore.getHeaterFanRingCondensatePan$ | async as fanRingFeature">
    <ng-container *ngIf="fanRingFeature.fanRing || fanRingFeature.condensatePan">
      <app-fan-ring-condensate-pan-heater
        [fanRingFeature]="fanRingFeature"
      ></app-fan-ring-condensate-pan-heater>
    </ng-container>
  </ng-container>

  <!-- defrost section -->
  <ng-container *ngIf="heatingCoolingCircuitRemoteDefrost$ | async | ready as feature">
    <app-defrosting-remote-trigger [feature]="feature"></app-defrosting-remote-trigger>
  </ng-container>
</div>
